var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Button, Dropdown, Icon, Menu, message, Modal, Table } from 'antd';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { Fragment } from 'react';
import * as React from 'react';
import form from 'src/shared/decorators/form';
import Page from 'src/shared/layout/Page';
import services from 'src/shared/services/services';
import stores from 'src/stores/stores';
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.model = [];
        _this.selected = [];
        _this.modal = {
            loading: false,
            basvuru: false,
            basvuruLink: ''
        };
        _this.columns = [];
        _this.filters = [];
        _this.filter = '';
        _this.refresh = function () {
            _this.loading = true;
            // this.props.form.validateFields();
            services.Company.getAllInactive(_this.filters, undefined)
                .then(function (c) {
                _this.model = c;
                _this.loading = false;
            })
                .catch(function () {
                _this.loading = false;
            });
        };
        return _this;
    }
    default_1.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var menu;
            var _this = this;
            return __generator(this, function (_a) {
                this.refresh();
                menu = function (c, row) { return (React.createElement(Dropdown, { overlay: React.createElement(Menu, { onClick: function (e) {
                            if (e.key === 'detail') {
                                window.open('/common/company/' + row.id);
                            }
                            else if (e.key === 'delete') {
                                _this.delete(row.id);
                            }
                        } },
                        React.createElement(Menu.Item, { key: "detail" }, "Detay"),
                        stores.auth.hasRole('administrator') && React.createElement(Menu.Item, { key: "delete" }, "Sil")) },
                    React.createElement(Button, null,
                        "\u0130\u015Flem ",
                        React.createElement(Icon, { type: "down" })))); };
                this.columns = [
                    { dataIndex: 'email', title: 'Email' },
                    { dataIndex: 'basvuruNo', title: 'Başvuru No' },
                    { dataIndex: 'name', title: 'Firma Adı' },
                    { dataIndex: 'createdOn', title: 'İlk Başvuru Tarihi', render: function (c) { return c.format('DD.MM.YYYY'); } },
                    { dataIndex: 'basvuruTarihi', title: 'Son Güncelleme Tarihi', render: function (c) { return c && c.format('DD.MM.YYYY'); } },
                    { dataIndex: 'status', title: 'Başvuru Durumu' }
                ];
                this.columns.push({ dataIndex: 'actions', title: 'İşlem', render: menu });
                return [2 /*return*/];
            });
        });
    };
    default_1.prototype.delete = function (id) {
        var _this = this;
        Modal.confirm({
            title: 'Veriyi silmek istediğinizden emin misiniz?',
            onOk: function () {
                services.Company.delete(id).then(function () {
                    message.success('Veri silindi..');
                    _this.refresh();
                });
            }
        });
    };
    default_1.prototype.render = function () {
        var _this = this;
        var getFieldDecorator = this.props.form.getFieldDecorator;
        return (React.createElement(Page, { buttons: React.createElement(Fragment, null,
                React.createElement(Button, { icon: "reload", style: { marginLeft: '10px' }, onClick: this.refresh }, "Yenile")), title: "S\u00FCresi Ge\u00E7mi\u015F Ba\u015Fvuru Listesi", loading: this.loading },
            React.createElement("div", { className: "card-header" },
                React.createElement("h5", { className: "card-title" }, "S\u00FCresi Ge\u00E7mi\u015F Ba\u015Fvuru Listesi")),
            React.createElement("div", { className: "card-body" },
                React.createElement(Table, { columns: this.columns, dataSource: this.model.filter(function (c) {
                        var ff = _this.filter.toLocaleLowerCase().trim();
                        return (c.name && c.name.toLocaleLowerCase().indexOf(ff) > -1) || (c.basvuruNo && c.basvuruNo.toLocaleLowerCase().indexOf(ff)) > -1;
                    }), pagination: {
                        showSizeChanger: true,
                        defaultPageSize: Number(localStorage.getItem('pagination_size')) || 10,
                        onShowSizeChange: function (current, size) {
                            localStorage.setItem('pagination_size', size.toString());
                        }
                    }, size: "small", rowKey: "id", rowSelection: {
                        onChange: function (_, rows) {
                            _this.selected = rows;
                        }
                    } }))));
    };
    __decorate([
        observable
    ], default_1.prototype, "loading", void 0);
    __decorate([
        observable
    ], default_1.prototype, "model", void 0);
    __decorate([
        observable
    ], default_1.prototype, "selected", void 0);
    __decorate([
        observable
    ], default_1.prototype, "modal", void 0);
    __decorate([
        observable
    ], default_1.prototype, "columns", void 0);
    __decorate([
        observable
    ], default_1.prototype, "filters", void 0);
    __decorate([
        observable
    ], default_1.prototype, "filter", void 0);
    default_1 = __decorate([
        form,
        observer
    ], default_1);
    return default_1;
}(React.Component));
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/app/common/company/ListInactive.tsx
// module id = 1265
// module chunks = 0